<style scoped>
.page-content {
    flex: 1;

    overflow-y: auto;
    padding-bottom: 70px;
}

/* 头部信息 */
.header-info {
    background: white;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.info-label {
    color: #666;
    font-size: 15px;
}

.info-value {
    font-size: 15px;
    font-weight: 500;
    color: #333;
}

/* 储存编号选择 */
.storage-selection {
    background: white;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.selection-title {
    font-size: 16px;
    font-weight: 600;
    color: #3498db;
    margin-bottom: 15px;
}

.storage-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.storage-option {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s;
}

.storage-option.selected {
    border-color: #3498db;
    background: #e8f4fc;
}

.storage-option input[type="radio"] {
    margin-right: 10px;
}

.storage-code {
    font-weight: 500;
}

/* 账单列表 */
.bills-container {
    background: white;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.bill-item {
    padding: 15px 0;
    border-bottom: 1px dashed #eee;
}

.bill-item:last-child {
    border-bottom: none;
}

.bill-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.bill-title {
    font-size: 15px;
    font-weight: 500;
}

.bill-status {
    font-size: 14px;
    padding: 4px 10px;
    border-radius: 20px;
}

.status-paid {
    background: #e8f6f0;
    color: #2ecc71;
}

.status-unpaid {
    background: #feecf0;
    color: #e74c3c;
}

.bill-amount {
    font-size: 18px;
    font-weight: 600;
    color: #e74c3c;
    margin: 8px 0;
}

.bill-desc {
    font-size: 13px;
    color: #888;
    margin-bottom: 10px;
}

.bill-action {
    text-align: right;
}

.pay-btn {
    background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%);
    color: white;
    border: none;
    border-radius: 20px;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
}

.pay-btn:hover {
    opacity: 0.9;
    transform: translateY(-2px);
}

/* 续存按钮 */
.renew-container {
    background: white;
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    text-align: center;
}

.renew-btn {
    background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%);
    color: white;
    border: none;
    border-radius: 10px;
    padding: 15px 30px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    width: 100%;
    transition: all 0.3s;
}

.renew-btn:hover {
    opacity: 0.9;
    transform: translateY(-2px);
}

/* 底部导航栏 */
.tab-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: white;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-top: 1px solid #eee;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    z-index: 100;
    max-width: 420px;
    margin: 0 auto;
}

.tab-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;
    cursor: pointer;
    transition: all 0.3s;
    color: #999;
}

.tab-item.active {
    color: #3498db;
}

.tab-icon {
    font-size: 20px;
    margin-bottom: 4px;
}

.tab-name {
    font-size: 12px;
}
</style>

<template>

    <div class="page-content">
        <!-- 头部信息 -->
        <div class="header-info">
            <div class="info-row">
                <div class="info-label">姓名：</div>
                <div class="info-value">张三</div>
            </div>
            <div class="info-row">
                <div class="info-label">储户编号：</div>
                <div class="info-value">HC202512345</div>
            </div>
        </div>

        <!-- 储存编号选择 -->
        <div class="storage-selection">
            <div class="selection-title">选择储存编号：</div>
            <div class="storage-options">
                <label class="storage-option" :class="{ selected: selectedStorage === 'HC202512345-1' }">
                    <input type="radio" value="HC202512345-1" v-model="selectedStorage">
                    <span class="storage-code">HC202512345-1</span>
                </label>
                <label class="storage-option" :class="{ selected: selectedStorage === 'HC202512345-2' }">
                    <input type="radio" value="HC202512345-2" v-model="selectedStorage">
                    <span class="storage-code">HC202512345-2</span>
                </label>
            </div>
        </div>

        <!-- 账单列表 -->
        <div class="bills-container">
            <!-- 第1期账单 -->
            <div class="bill-item">
                <div class="bill-header">
                    <div class="bill-title">第1期储存 2025.02.15-2028.02.14</div>
                    <div class="bill-status status-paid">已支付</div>
                </div>
                <div class="bill-amount">￥1800.00</div>
                <div class="bill-desc">已于2025.2.15完成支付</div>
            </div>

            <!-- 分隔线 -->
            <div style="height: 1px; background: #eee; margin: 10px 0;"></div>

            <!-- 第2期账单 -->
            <div class="bill-item">
                <div class="bill-header">
                    <div class="bill-title">第2期储存 2028.02.15-2029.02.14</div>
                    <div class="bill-status status-unpaid">待支付</div>
                </div>
                <div class="bill-amount">￥600.00</div>
                <div class="bill-desc">请于2025.6.30前完成支付</div>
                <div class="bill-action">
                    <button class="pay-btn" @click="goToPayment">去支付</button>
                </div>
            </div>
        </div>

        <!-- 续存按钮 -->
        <div class="renew-container">
            <button class="renew-btn" @click="renewStorage">我要续存</button>
        </div>
    </div>

</template>

<script>
import router from '../router';
export default {
    name: 'Bill',
    data() {
        return {
            currentTab: 'mine',
            selectedStorage: 'HC202512345-1'
        }
    },
    methods: {

        goToPayment() {
            router.push('/daizhifu');
            // 实际应用中：跳转到支付页面
        },
        renewStorage() {
            router.push('/xucun');
            // 实际应用中：跳转到续存页面
        }
    }
};
</script>
